const AD_FAVORITED = 'Ad Favorited'
const AD_IMPRESSIONS_COLLECTED = 'Ad Impressions Collected'
const AD_INSERTED = 'Ad Inserted'
const AD_INSERTED_ERROR = 'Ad Inserted Error'
const AD_INSERTION_BUTTON_CLICKED = 'Ad Insertion Button Clicked'
const AD_INSERTION_FIELD_AUTOCOMPLETED = 'Ad Insertion Field Autocompleted'
const AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED = 'Ad Insertion IO Confirmation Faq Expanded'
const AD_INSERTION_IO_DATE_CONFIRMED = 'Ad Insertion IO Date Confirmed'
const AD_INSERTION_IO_DATE_SELECTED = 'Ad Insertion IO Date Selected'
const AD_INSERTION_IO_DEALER_SELECTED = 'Ad Insertion IO Dealer Selected'
const AD_INSERTION_IO_DEALERS_AND_DATES_VIEWED = 'Ad Insertion IO Dealers And Dates Viewed'
const AD_INSERTION_IO_HOUR_SELECTED = 'Ad Insertion IO Hour Selected'
const AD_INSERTION_IO_NO_OFFER_AVAILABLE = 'Ad Insertion IO No Offer Available'
const AD_INSERTION_IO_VIEWED = 'Ad Insertion IO Viewed'
const AD_INSERTION_VIEWED = 'Ad Insertion Viewed'
const AD_MODIFIED = 'Ad Modified'
const AD_SHARED = 'Ad Shared'
const AI_SEARCH_USED = 'Ai Search Used'
const ALERT_CREATED = 'Alert Created'
const APP_DOWNLOAD_BUTTON_CLICKED = 'App Download Button Clicked'
const APPRAISAL_REQUESTED = 'Appraisal Requested'
const APPRAISAL_SELECT_DEALER_CONFIRMED = 'Appraisal Select Dealer Confirmed'
const DEALER_STOCK_CLICKED = 'Dealer Stock Clicked'
const DETAIL_NAVBAR_CLICKED = 'Detail Navbar Clicked'
const DETAIL_VIEWED = 'Detail Viewed'
const FILTER_ADDED = 'Filter Added'
const FILTERS_RESTART_CLICKED = 'Filters Restart Clicked'
const HOME_VIEWED = 'Home Viewed'
const HOME_IO_BUTTON_CLICKED = 'Home IO Button Clicked'
const INSTANT_OFFER_NEXT_CONFIRMED = 'Instant Offer Next Confirmed'
const INSTANT_OFFER_FORM_VIEWED = 'Instant Offer Form Viewed'
const AD_INSERTION_IO_CAR_DETAILS_SUCCESS = 'Ad Insertion IO Car Details Success'
const LANDING_IO_DATE_CONFIRMED = 'Landing IO Date Confirmed'
const LANDING_IO_NEXT_CONFIRMED = 'Landing IO Next Confirmed'
const LANDING_IO_VIEWED = 'Landing IO Viewed'
const LAST_DETAILS_SEEN = 'Last Details Seen'
const LEAD_ENRICHED = 'Lead Enriched'
const LEAD_ERROR = 'Lead Error'
const LEAD_TRIGGERED = 'Lead Triggered'
const LIST_VIEWED = 'List Viewed'
const MAP_CLICKED = 'Map Clicked'
const LIST_NEWS_SAVED_CLICKED = 'List News Saved Clicked'
const LIST_NEWS_SAVED_VIEWED = 'List News Saved Viewed'
const NEWS_DETAIL_VIEWED = 'Detail News Viewed'
const PHONE_VIEWED = 'Phone Viewed'
const RESERVATION_INFORMATION_CLICKED = 'Reservation Information Clicked'
const RESERVATION_START_CLICKED = 'Reservation Start Clicked'
const RESERVATION_SUCCESS = 'Reservation Success'
const RESERVATION_MORE_INFORMATION_CLICKED = 'Reservation More Information Clicked'
const RESERVATION_MANAGE_CLICKED = 'Reservation Manage Clicked'
const RESERVATION_DRAWER_VIEWED = 'Reservation Drawer Viewed'
const RESERVATION_PAYMENT_VIEWED = 'Reservation Payment Viewed'
const SEND_MESSAGE_BUTTON_CLICKED = 'Send Message Button Clicked'
const SIGNED_IN = 'Signed In'
const SIGNED_IN_ERROR = 'Signed In Error'
const SIGNED_UP = 'Signed Up'
const SIGNED_UP_ERROR = 'Signed Up Error'
const WEBSITE_CLICKED = 'Website Clicked'
const ACCESS_TO_AD_INSERTION_CLICKED = 'Access To Ad Insertion Clicked'
const ACCESS_TO_INSTANT_OFFER_CLICKED = 'Access To Instant Offer Clicked'
const RECOMMENDED_ADS_FALLBACK = 'Recommended Ads Fallback'

const events = {
  ACCESS_TO_AD_INSERTION_CLICKED,
  ACCESS_TO_INSTANT_OFFER_CLICKED,
  AD_FAVORITED,
  AD_IMPRESSIONS_COLLECTED,
  AD_INSERTED,
  AD_INSERTED_ERROR,
  AD_INSERTION_BUTTON_CLICKED,
  AD_INSERTION_FIELD_AUTOCOMPLETED,
  AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED,
  AD_INSERTION_IO_DATE_CONFIRMED,
  AD_INSERTION_IO_DATE_SELECTED,
  AD_INSERTION_IO_DEALERS_AND_DATES_VIEWED,
  AD_INSERTION_IO_DEALER_SELECTED,
  AD_INSERTION_IO_HOUR_SELECTED,
  AD_INSERTION_IO_NO_OFFER_AVAILABLE,
  AD_INSERTION_IO_VIEWED,
  AD_INSERTION_VIEWED,
  AD_MODIFIED,
  AD_SHARED,
  AI_SEARCH_USED,
  ALERT_CREATED,
  APP_DOWNLOAD_BUTTON_CLICKED,
  APPRAISAL_REQUESTED,
  APPRAISAL_SELECT_DEALER_CONFIRMED,
  DEALER_STOCK_CLICKED,
  DETAIL_NAVBAR_CLICKED,
  DETAIL_VIEWED,
  FILTERS_RESTART_CLICKED,
  FILTER_ADDED,
  HOME_VIEWED,
  HOME_IO_BUTTON_CLICKED,
  AD_INSERTION_IO_CAR_DETAILS_SUCCESS,
  INSTANT_OFFER_FORM_VIEWED,
  INSTANT_OFFER_NEXT_CONFIRMED,
  LANDING_IO_DATE_CONFIRMED,
  LANDING_IO_NEXT_CONFIRMED,
  LANDING_IO_VIEWED,
  LAST_DETAILS_SEEN,
  LEAD_ENRICHED,
  LEAD_ERROR,
  LEAD_TRIGGERED,
  LIST_NEWS_SAVED_CLICKED,
  LIST_NEWS_SAVED_VIEWED,
  LIST_VIEWED,
  MAP_CLICKED,
  NEWS_DETAIL_VIEWED,
  PHONE_VIEWED,
  RESERVATION_INFORMATION_CLICKED,
  RESERVATION_START_CLICKED,
  RESERVATION_SUCCESS,
  RESERVATION_MORE_INFORMATION_CLICKED,
  RESERVATION_MANAGE_CLICKED,
  RESERVATION_DRAWER_VIEWED,
  RESERVATION_PAYMENT_VIEWED,
  RECOMMENDED_ADS_FALLBACK,
  SEND_MESSAGE_BUTTON_CLICKED,
  SIGNED_IN,
  SIGNED_IN_ERROR,
  SIGNED_UP,
  SIGNED_UP_ERROR,
  WEBSITE_CLICKED
}

export default events
